

































import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import zoneStore from '@/stores/ZoneStore'

@Component
export default class ZonesTableHeader extends Vue {
  @Prop(String)
  value: string
  isPending: boolean = false
  zoneName: string = ''

  zoneStore = zoneStore

  emitInput(value: string) {
    this.$emit('input', value)
  }

  async createZone() {
    this.isPending = true
    await this.zoneStore.createZone(this.zoneName)
    this.zoneName = ''
    this.isPending = false
  }
}
